import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'PetaJabatan'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const tugasTambahanCreate = 'Kepegawaian/TugasTambahan/create/'
export const tugasTambahanCheck = 'Kepegawaian/TugasTambahan/cek_tugas_tambahan/'
export const tugasTambahanUpdate = 'Kepegawaian/TugasTambahan/update/'
export const tugasTambahanDetail = 'Kepegawaian/TugasTambahan/detail/'
export const tugasTambahanList = 'Kepegawaian/TugasTambahan/list/'
export const tugasTambahanInactive = 'Kepegawaian/TugasTambahan/inactive/'
export const tugasTambahanDetailInactive = 'Kepegawaian/TugasTambahan/detailInactive/'
export const tugasTambahanListPegawai = 'Kepegawaian/TugasTambahan/listPegawai/'
export const tugasTambahanListJabatan = 'Kepegawaian/TugasTambahan/listJabatan/'
export const tugasTambahanListUnitKerja = 'Kepegawaian/TugasTambahan/listUnitKerja/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}